module.exports = __webpack_public_path__ + "img/22.95af6a06.jpg";